import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const SpeakerIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 9L3 15L7 15L12 20L12 4L7 9L3 9ZM10 8.83L10 15.17L7.83 13L5 13L5 11L7.83 11L10 8.83ZM16.5 12C16.5 10.23 15.48 8.71 14 7.97L14 16.02C15.48 15.29 16.5 13.77 16.5 12ZM14 3.23L14 5.29C16.89 6.15 19 8.83 19 12S16.89 17.85 14 18.71L14 20.77C18.01 19.86 21 16.28 21 12S18.01 4.14 14 3.23Z"
      fill="currentColor"
    />
  </svg>
);

SpeakerIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(SpeakerIcon);
